import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryData } from './useQueryData';
import { useRedirect } from './useRedirect';
import AppleLoginDao from '../data/AppleLoginDao';
import LoginFailureHandlerFactory from '../lib/LoginFailureHandlerFactory';
import { returnLoginRedirectOrChatspotRedirect } from '../utils/urls';
const appleLoginDao = new AppleLoginDao();
export const useAppleLogin = ({
  handleError,
  requiredPortalId,
  rememberLogin
}) => {
  const history = useHistory();
  const {
    queryData
  } = useQueryData();
  const {
    loginPortalId,
    loginRedirectUrl
  } = queryData;
  const {
    redirectToUrl
  } = useRedirect(queryData);
  const portalId = requiredPortalId || loginPortalId;
  const loginWithApple = useCallback(() => {
    appleLoginDao.initialize({
      loginPortalId: portalId,
      loginRedirectUrl: returnLoginRedirectOrChatspotRedirect(loginRedirectUrl, portalId),
      rememberLogin
    }).then(res => {
      const {
        redirectUrl
      } = res;
      redirectToUrl(redirectUrl);
    }).catch(LoginFailureHandlerFactory.createRavenReporter('Apple initialization failed', err => {
      if (handleError) {
        handleError(err);
      }
    }, history.push));
  }, [handleError, loginRedirectUrl, history, redirectToUrl, portalId, rememberLogin]);
  return useMemo(() => ({
    loginWithApple
  }), [loginWithApple]);
};